import React from "react";
import { Container, Row, Col, Button } from "reactstrap";
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from "react-share";

function news({ news }) {
  const shareUrl = "www.finnovex.com/finnovexlive/";
  return (
    <>
      <Container>
        <Row className="py-4">
          <Col lg={6}>
            <div className="owner">
              <div className="avatar-big text-center">
                <img
                  alt=""
                  className="img-no-padding img-responsive img-rounded pt-2"
                  src={require(`assets/images/news/${news.image}`)}
                  width={"400px"}
                />
              </div>
            </div>
          </Col>
          <Col lg={6} className="align-self-center mt-3 text-white">
            <h5 className="text-white">
              I envision creating an agile, data-driven banking ecosystem to enhance customer
              experience and operational efficiency. My goal is to modernize core banking
              infrastructure and expand digital capabilities to meet our ambitious business
              strategy.
              <br />
              <br />
              Through leveraging AI and data analytics to transform customer interactions and risk
              management. Where applicable, I will use cloud computing to enhance scalability and
              cost optimization, enabling effective deployment of digital services. These
              technologies are transforming banking in North Africa by improving accessibility,
              operational resilience, and regulatory compliance.
              <br />
              <br />
              We do address cyber threats with a proactive, multi-layered framework, AI-driven
              threat intelligence, and zero-trust architecture complying with ISO and PCI-DSS
              standards. Investing in real-time monitoring and encryption to strengthen our digital
              resilience and security posture.
              <br />
              <br />I keep building high-performing IT teams through continuous development,
              technical expertise, adaptability, and innovation enablement . Talent development and
              collaboration with fintechs is my main focus.
              <br />
              <br />I believe collaboration between banks, fintechs, and regulators is crucial for
              driving innovation. Open banking and API-driven ecosystems facilitate seamless
              integrations and foster innovation. Strategic partnerships drive innovation in digital
              payments, embedded finance, and data-driven banking solutions.
              <br />
              <br />I see the banking sector evolving towards a digital-first model with AI-powered
              services and embedded banking. My focus is always on quality, process reengineering,
              cybersecurity, and personalized experiences to meet and exceed customer expectations.
              <br />
              <br />
            </h5>
          </Col>
        </Row>

        <Row>
          <Col xs={1} className="d-none d-xl-block d-lg-block d-md-block"></Col>
          <FacebookShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                  marginLeft: "15px",
                }}
              >
                <span style={{ color: "#3b5998", display: "inline" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-facebook-square float-left" />
                </span>
              </Button>
            }
          />

          <LinkedinShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#0976b4" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-linkedin-square float-left" />
                </span>
              </Button>
            }
          />
          <TwitterShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                outline
                style={{
                  padding: 0,
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#55acee" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-twitter-square float-left" />
                </span>
              </Button>
            }
          />
        </Row>

        <Row>
          <Col className={"ml-auto mr-auto text-justify"} md="10">
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-As a CIO, you play a critical role in defining and executing the bank’s IT
                strategy. How do you balance innovation with maintaining the stability and security
                of banking operations?
              </strong>
            </h5>

            <h5 className="text-white">
              <b>Vision for Digital Transformation</b> I envision creating an agile, data-driven
              banking ecosystem to enhance customer experience and operational efficiency. My goal
              is to modernize core banking infrastructure and expand digital capabilities to meet
              our ambitious business strategy.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-You are known for your ability to build high-performing teams. What key qualities
                do you look for when hiring IT professionals, and how do you foster a culture of
                collaboration and continuous improvement?
              </strong>
            </h5>
            <h5 className="text-white">
              <b>Impactful Emerging Technologies</b> Through leveraging AI and data analytics to
              transform customer interactions and risk management. Where applicable, I will use
              cloud computing to enhance scalability and cost optimization, enabling effective
              deployment of digital services. These technologies are transforming banking in North
              Africa by improving accessibility, operational resilience, and regulatory compliance.
            </h5>
            <br />
            <h5 className="text-white">
              <strong>
                Q-The banking industry is rapidly evolving with advancements in AI, blockchain, and
                cloud computing. Which emerging technologies do you see as most transformative for
                the banking sector, and how is your team integrating them into operations?
              </strong>
            </h5>
            <h5 className="text-white">
              <b>Cybersecurity</b> We do address cyber threats with a proactive, multi-layered
              framework, AI-driven threat intelligence, and zero-trust architecture complying with
              ISO and PCI-DSS standards. Investing in real-time monitoring and encryption to
              strengthen our digital resilience and security posture.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-Cybersecurity is a top priority for financial institutions. What are the biggest
                cybersecurity threats banks face today, and what strategies do you implement to
                ensure robust data protection and risk mitigation?
              </strong>
            </h5>
            <h5 className="text-white">
              <b>IT Teams</b> I keep building high-performing IT teams through continuous
              development, technical expertise, adaptability, and innovation enablement . Talent
              development and collaboration with fintechs is my main focus.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-Digital transformation is reshaping customer expectations. How do you ensure that
                technology initiatives not only enhance operational efficiency but also improve
                customer experiences and engagement?
              </strong>
            </h5>
            <h5 className="text-white">
              <b>Customer Experience</b> Through enhancing accessibility and convenience with
              AI-driven personalization, biometric authentication, and omnichannel banking.
              Real-time analytics and self-service platforms empower customers with smarter
              financial management tools while ensuring a secure and frictionless banking
              experience.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-You actively collaborate with educational institutions to address IT skill
                shortages. What are some effective strategies you’ve found for bridging the talent
                gap in the banking and financial technology sectors?
              </strong>
            </h5>
            <h5 className="text-white">
              <b>Financial Innovation</b> I believe collaboration between banks, fintechs, and
              regulators is crucial for driving innovation. Open banking and API-driven ecosystems
              facilitate seamless integrations and foster innovation. Strategic partnerships drive
              innovation in digital payments, embedded finance, and data-driven banking solutions.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-Automation and strategic outsourcing can significantly impact efficiency and cost
                management. How do you determine which IT functions to automate or outsource while
                maintaining control over critical operations?
              </strong>
            </h5>
            <h5 className="text-white">
              <b>Future of Banking</b> I see the banking sector evolving towards a digital-first
              model with AI-powered services and embedded banking. My focus is always on quality,
              process reengineering, cybersecurity, and personalized experiences to meet and exceed
              customer expectations.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-Closing Remark-You will be speaking at Finnovex North Africa on April 23rd. What
                key message or takeaway would you like the audience to leave with from your session,
                especially regarding the role of technology in shaping the future of banking in the
                region?
              </strong>
            </h5>
            <h5 className="text-white">
              <b>Closing Remarks</b> Continuous Innovation, security, and adaptability will drive
              the future of banking. Embracing AI and cloud computing where applicable will ensure
              sustainable growth and customer-centric banking services/products.
            </h5>
            <br />
            <br />
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default news;
